import {createFileRoute} from '@tanstack/react-router';

import {AdminStatusPage} from '@/modules/admin/pages/AdminStatusPage';

export const Route = createFileRoute('/_authenticated/admin/')({
  component: AdminStatusPage,
});
